const carousels = document.querySelectorAll('[data-info-carousel]')

Array.prototype.forEach.call(carousels, carousel => {
  const carouselButtons = carousel.querySelectorAll('[data-info-carousel-button]')
  const carouselList = carousel.querySelector('[data-info-carousel-list]')

  Array.prototype.forEach.call(carouselButtons, carouselButton => {
    carouselButton.addEventListener('click', () => {
      const targetCarouselItemId = carouselButton.getAttribute('data-info-carousel-button')
      const targetCarouselItem = carousel.querySelector(`[data-info-carousel-item="${targetCarouselItemId}"]`)
      const offset = targetCarouselItem.offsetLeft
      carouselList.scroll({ left: offset, behavior: 'smooth' })
    })
  })
})
